import { render, staticRenderFns } from "./StockItemToGroup.vue?vue&type=template&id=2797efb5&scoped=true&"
import script from "./StockItemToGroup.vue?vue&type=script&lang=js&"
export * from "./StockItemToGroup.vue?vue&type=script&lang=js&"
import style0 from "./StockItemToGroup.vue?vue&type=style&index=0&id=2797efb5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2797efb5",
  null
  
)

export default component.exports